function isGranted(role) {
  const permissions = localStorage.getItem('permissions');

  return permissions ? permissions.includes(role) : false;
}

export {
  isGranted,
}